// Namespace URLs
export const NS_URI_SELF = 'http://fonto-documentation-website-spa';
export const NS_URI_FAD = 'http://www.fontoxml.com/ns/api-documentation';

// Commonly found in the @xsi:noNamespaceSchemaLocation attribute
export const SCHEMA_URI_FAD_1 = 'urn:fontoxml:names:fad:xsd:fad.xsd';
export const SCHEMA_URI_FAD_2 = 'urn:fontoxml:names:fad:2:xsd:fad.xsd';

export const HARDCODED_ASSET_LOCATION_IN_CONTENT_REPO = 'assets/';
